export enum CardType {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  AMEX = 'AMEX',
  UNKNOWN = 'UNKNOWN',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/card-type.ts